/**
 * The lightbox: thumbnails printed by wgi_the_gallery() open full size in
 * `#lightbox`, with previous and next stepping through their row.
 */
( function() {
	const dialog = document.getElementById( 'lightbox' );

	if ( ! dialog || 'function' !== typeof dialog.showModal ) {
		return;
	}

	const image = dialog.querySelector( '.image' );
	const caption = dialog.querySelector( '.caption .text' );
	const count = dialog.querySelector( '.caption .count' );
	const prev = dialog.querySelector( '.prev' );
	const next = dialog.querySelector( '.next' );

	let thumbs = [];
	let index = 0;

	/**
	 * Show one thumbnail's image, wrapping around at either end.
	 *
	 * @param {number} position Index into the current row.
	 */
	function show( position ) {
		index = ( position + thumbs.length ) % thumbs.length;

		const thumb = thumbs[ index ];
		const preview = thumb.querySelector( 'img' );

		// The stylesheet sizes the image from these, so it fits before it loads.
		image.style.setProperty( '--width', Number( thumb.dataset.width ) || 1 );
		image.style.setProperty( '--height', Number( thumb.dataset.height ) || 1 );
		image.src = thumb.dataset.src;
		image.alt = preview ? preview.alt : '';

		caption.textContent = image.alt;
		count.textContent = thumbs.length > 1 ? ( index + 1 ) + ' / ' + thumbs.length : '';

		// Fetch the neighbours so stepping does not wait on the network.
		[ index - 1, index + 1 ].forEach( function( near ) {
			const neighbour = thumbs[ ( near + thumbs.length ) % thumbs.length ];

			if ( neighbour !== thumb ) {
				new Image().src = neighbour.dataset.src;
			}
		} );
	}

	document.querySelectorAll( '[data-gallery]' ).forEach( function( gallery ) {
		const row = Array.from( gallery.querySelectorAll( '.thumb[data-src]' ) );

		row.forEach( function( thumb, position ) {
			thumb.addEventListener( 'click', function() {
				thumbs = row;
				dialog.classList.toggle( 'is-single', row.length < 2 );
				show( position );
				dialog.showModal();
			} );
		} );
	} );

	prev.addEventListener( 'click', function() {
		show( index - 1 );
	} );

	next.addEventListener( 'click', function() {
		show( index + 1 );
	} );

	dialog.addEventListener( 'keydown', function( event ) {
		if ( thumbs.length < 2 ) {
			return;
		}

		if ( 'ArrowLeft' === event.key ) {
			event.preventDefault();
			show( index - 1 );
		} else if ( 'ArrowRight' === event.key ) {
			event.preventDefault();
			show( index + 1 );
		}
	} );

	// Swipe on touch screens.
	let startX = null;

	dialog.addEventListener( 'touchstart', function( event ) {
		startX = 1 === event.touches.length ? event.touches[ 0 ].clientX : null;
	}, { passive: true } );

	dialog.addEventListener( 'touchend', function( event ) {
		if ( null === startX || thumbs.length < 2 ) {
			return;
		}

		const distance = event.changedTouches[ 0 ].clientX - startX;

		startX = null;

		if ( Math.abs( distance ) > 50 ) {
			show( index + ( distance < 0 ? 1 : -1 ) );
		}
	} );

	// Hand focus back to the image the reader ended on, not the one they opened.
	dialog.addEventListener( 'close', function() {
		if ( thumbs[ index ] ) {
			thumbs[ index ].focus( { preventScroll: true } );
		}
	} );
}() );
